import React from 'react';
import { CreditCard, Calendar, DollarSign, CheckCircle } from 'lucide-react';

const PaymentSection = ({ onOpenForm }) => {
  const benefits = [
    { icon: CreditCard, title: '12x Boleto' },
    { icon: CheckCircle, title: 'Sem Análise' },
    { icon: Calendar, title: 'Planejamento' },
    { icon: DollarSign, title: 'Melhor Preço' }
  ];

  return (
    <section className="py-8 md:py-12 bg-gradient-to-br from-red-600 via-red-700 to-orange-600 text-white">
      <div className="container mx-auto px-3 sm:px-6 lg:px-8 max-w-5xl">
        {/* Header */}
        <div className="text-center mb-4 md:mb-8">
          <h2 className="text-xl md:text-3xl font-bold mb-2">
            Pagamento <span className="text-yellow-300">Facilitado</span>
          </h2>
          <p className="text-sm md:text-lg text-white/90">
            Realize o sonho da sua viagem com condições especiais
          </p>
        </div>

        {/* Benefits Grid - Compact */}
        <div className="grid grid-cols-4 gap-2 md:gap-4 mb-6 md:mb-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-lg p-2 md:p-4 text-center border border-white/20"
            >
              <div className="w-8 h-8 md:w-12 md:h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-1 md:mb-2">
                <benefit.icon className="w-4 h-4 md:w-6 md:h-6 text-white" />
              </div>
              <p className="text-[10px] md:text-sm font-bold">{benefit.title}</p>
            </div>
          ))}
        </div>

        {/* Highlight Box - Compact */}
        <div className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 text-center shadow-xl max-w-2xl mx-auto">
          <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-2">
            Parcele em até <span className="text-red-600">12x no Boleto</span>
          </h3>
          <p className="text-xs md:text-base text-gray-600 mb-3">
            Sem análise de crédito • Sem burocracia • Sem complicação
          </p>
          <div className="inline-block bg-green-50 border border-green-500 rounded-lg px-3 py-2 mb-4">
            <p className="text-gray-700 text-xs md:text-sm font-semibold">
              ✓ Aprovação imediata • ✓ 100% online • ✓ Seguro
            </p>
          </div>
          <br />
          <button
            onClick={onOpenForm}
            className="bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-bold py-2 px-6 md:py-3 md:px-8 rounded-full text-sm md:text-base transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Consultar Condições
          </button>
        </div>
      </div>
    </section>
  );
};

export default PaymentSection;
